import { render, staticRenderFns } from "./applygdtdouying1.vue?vue&type=template&id=15281172&scoped=true&"
import script from "./applygdtdouying1.vue?vue&type=script&lang=js&"
export * from "./applygdtdouying1.vue?vue&type=script&lang=js&"
import style0 from "./applygdtdouying1.vue?vue&type=style&index=0&id=15281172&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15281172",
  null
  
)

export default component.exports